<template>
    <div @click.stop="">
      <h3 class="editor-header">{{ editorTitle }}</h3>
      <div>
        <div class="row">
          <div class="col-sm-6">
            <span class="item-detail-title">{{ $t('contract_reports.date') }}</span>
            <date-time-picker
              id="weatherTime"
              v-model:date="materialReport.reporting_date"
              class="routa-input"
              format="dd.MM.yyyy HH:mm"
              :enableTimePicker="true"
            />
          </div>
          <div class="col-sm-6">
            <span class="item-detail-title">{{ $t('material_reports.material') }}</span>
              <input
                  id="material"
                  v-model="materialReport.material"
                  type="text"
                  class="form-control form-control-sm"
                  :placeholder="$t('material_reports.material')"
                  autofocus
              />

          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <span class="item-detail-title">{{ $t('material_reports.amount') }}</span>
              <input
                  id="amount"
                  v-model="materialReport.amount"
                  type="number"
                  class="form-control form-control-sm"
                  :placeholder="$t('material_reports.amount')"
              />
          </div>
          <div class="col-sm-6">
            <span class="item-detail-title">{{ $t('orders.unit') }}</span>
              <select
                  id="unit"
                  v-model="materialReport.unit"
                  class="form-select form-select-sm"
              >
                  <option :value="null">{{ $t('unit.select_unit') }}</option>
                  <option
                      v-for="option in unitOptions"
                      :key="option.text"
                      :value="option.value"
                  >
                      {{ option.text }}
                  </option>
              </select>
          </div>
        </div>
          <div class="row">
              <div v-if="materialReport.contract_name" class="col-sm-6">
                  <span class="item-detail-title">{{ $t('orders.contract') }}</span>
                  <span class="item-detail-text">{{ materialReport.contract_name ? materialReport.contract_name : "" }}</span>
              </div>
              <div v-else class="col-sm-6" style="padding-top: .4em">
                  <open-contract-filter
                      ref="contracts"
                      :from="materialReport.reporting_date"
                      :show-title="true"
                      :show-company="false"
                      :apply-padding="false"
                      @contract-selected="setContract"
                  />
              </div>
              <div class="col-sm-6">
                  <span class="item-detail-title">{{ $t('orders.order') }}</span>
                  <select
                      id="order"
                      v-model="order"
                      class="form-select form-select-sm sm-3"
                  >
                      <option :value="null">
                          {{ $t('menu.select_order') }}
                      </option>
                      <option
                          v-for="option in orders"
                          :key="option.id"
                          :value="option"
                      >
                          {{ option.contract_task_type.task_type.name }}
                      </option>
                  </select>
              </div>
          </div>

        <div class="row">
          <div class="col-sm-12 nopads">
            <span class="item-detail-title">{{ $t('common.info') }}</span>
              <textarea
                  id="info"
                  v-model="materialReport.info"
                  class="form-control"
                  rows="5"
              />
              <div
                v-if="showInfoValidation"
                class="text-danger"
              >
                {{ $t('material_reports.info_warning') }}
              </div>
          </div>
        </div>

        <div class="col-12 text-end my-2">
          <button class="btn btn-secondary form-button" @click.stop="close">
            {{ $t('common.close') }}
          </button>
          <button class="btn btn-success form-button" @click.stop="addMaterialReport">
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
  </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import DateTimePicker from "@/components/common/DateTimePicker";
import {inject} from "vue";
import OpenContractFilter from "@/components/contract/OpenContractFilter";

export default {
    name: 'ContractMaterialReportEditor',
    components: {OpenContractFilter, DateTimePicker },
    mixins: [restApi],
    props: {
        materialReport: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            orders: [],
            order: null,
            showInfoValidation: false,
            unitOptions : [
                {value: 'kpl', text: this.$t('unit.pcs')},
                {value: 'kg', text: this.$t('unit.kg')},
                {value: 't', text: this.$t('unit.tons')},
                {value: 'm', text: this.$t('unit.meters')},
                {value: 'km', text: this.$t('unit.km')},
                {value: 'm2', text: this.$t('unit.square_m')},
                {value: 'm3', text: this.$t('unit.cubic_m')},
                {value: 'l', text: this.$t('unit.liter')},
            ],
            panelIndex: 0
        }
    },
    computed: {
        editorTitle() {
            return this.materialReport.id < 0
                ? this.$t('material_reports.editor_title_new')
                : this.$t('material_reports.editor_title_existing');
        }
    },
    watch: {
        'materialReport.info': function(newValue) {
            // Only validate if `id > 0`
            if (this.materialReport.id > 0) {
                this.showInfoValidation = newValue === '' || newValue.length < 10;
            } else {
                this.showInfoValidation = false;
            }
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    mounted() {
        if(this.materialReport && this.materialReport.contract && this.materialReport.contract.id){
            this.fetchContractOrders()
        }
    },
    methods: {
        setContract(contract) {
            this.materialReport.contract = contract
            this.fetchContractOrders()
        },
        fetchContractOrders: function () {
            this.orders = []
            this.loading = true
            this.restFetchParams(this.orderUrl, {contract: this.materialReport.contract.id}, this.handleOrders)
        },
        handleOrders: function (response) {
            if (response != null) {
                this.orders = response.data
                if (this.orders.length > 0 && this.materialReport.work_order) {
                    this.order = this.orders.find(o => o.id === this.materialReport.work_order.id)
                }
                this.loading = false
            }
        },
        addMaterialReport() {
            if(this.materialReport.id > 0 && (this.materialReport.info === '' || this.materialReport.info.length < 10)) {
                this.showAlert(this.$t('material_reports.info_warning'))
                return undefined;
            }
            if(this.order) {
                this.materialReport.work_order = this.order
            }
            this.$emit('emitAddMaterialReport', this.materialReport)
        },
        close: function () {
            this.$emit('close')
        },

    }
}
</script>

